import 'slick-carousel';
import { resizeBackgroundImages } from "../utilities/responsive-images";

const $win = $(window);
const $doc = $(document);

const $sliders = $('.js-slider-default .slider__slides');
const sliderOptions = {
  slidesToShow: 4,
	slidesToScroll: 1,
	dots: false,
	arrows: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }
  ]
}

// Watch for recommendations product and init slider

const targetNode = $('#shopify-section-product-recommendations')[0];

if (targetNode) {
  const config = { childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if ($(node).hasClass('section-carousel')) {
              const $slider = $(node).find('.js-slider-default .slider__slides');

              $slider.slick(sliderOptions);
              handleLazyLoad($slider[0]);
              handleArrowPosition($slider[0]);

              observer.disconnect();
            }
          })
        }
      });
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}


$doc.on('shopify:section:load', function(event) {
	$sliders.slick(sliderOptions);

  $sliders.each((index, slider) => {
    handleLazyLoad(slider)
    handleArrowPosition(slider)
  })
})

$sliders.slick(sliderOptions);

$sliders.each((index, slider) => {
  handleLazyLoad(slider)
  handleArrowPosition(slider)
})

function handleLazyLoad (slider) {
  const sliderImages = slider.querySelectorAll(".responsive-background-image");
  const $slider = $(slider);

  $slider.on("refresh afterChange", function() {
    resizeBackgroundImages(sliderImages);
  });
}

function handleArrowPosition (slider) {
  const $slider = $(slider);

  $slider.on('setPosition', function() {
    const $firstSlide = $slider.find('.slick-slide:not(.slick-cloned) .product-item, .slick-slide:not(.slick-cloned) .block').first();
    const $firstSlideImage = $firstSlide.find('.product-item__image, .block__inner');
    let imageHeight = parseInt($slider.attr('data-image-height'));

    if (imageHeight === $firstSlideImage.height()) {
      return;
    }

    imageHeight = $firstSlideImage.height();
    $slider.attr('data-item-height', imageHeight);

    if ($slider.find('.slick-arrow').length) {
      $slider.find('.slick-arrow').css({
        top: imageHeight / 2,
        opacity: 1
      })
    }
  })
}
